import Teacher from '@/api/home/teacher'
import TeacherHomework from '@/api/eschool/teacher-homework'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  homework_status_id: null,
  subjectLists: [],
  classLists: [],
  date_from: moment()
    .add(-2, 'Month')
    .format('DD-MM-YYYY'),
  date_to: moment()
    .add(1, 'Month')
    .format('DD-MM-YYYY')
}

export const getters = {
  getTotalByClass: state => ({ class_id } = {}) => {
    if (class_id !== undefined && state.resources !== undefined) {
      return state.resources.filter(h => h.class_id == class_id).length
    }

    return 0
  },
  getTotalBySubject: state => ({ subject_id } = {}) => {
    if (subject_id !== undefined && state.resources !== undefined) {
      return state.resources.filter(h => h.subject_id == subject_id).length
    }

    return 0
  },
  getTotalByStatus: state => ({ status_id } = {}) => {
    if (status_id !== undefined && state.resources !== undefined) {
      return state.resources.filter(h => h.is_sent == status_id).length
    }

    return 0
  },
  getTotalByHomeworkStatus: state => ({ homework_status_id } = {}) => {
    if (homework_status_id !== undefined && state.resources !== undefined) {
      return state.resources.filter(
        h => h.homework_status_id == homework_status_id
      ).length
    }

    return 0
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_HOMEWORK_STATUS(state, value) {
    state.homework_status_id = value
  },
  SET_CLASS_LISTS(state, value) {
    state.classLists = value
  },
  SET_SUBJECT_LISTS(state, value) {
    state.subjectLists = value
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign({
      page: context.state.pagination.page,
      perPage: context.state.pagination.perPage,
      search: context.state.search,
      date_from: context.state.date_from,
      date_to: context.state.date_to,
      status: context.state.homework_status_id,
      ...attributes
    })
    return TeacherHomework.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  fetchClasses(context = {}) {
    return Teacher.getClasses().then(response => {
      context.commit('SET_CLASS_LISTS', response)
    })
  },

  fetchSubject(context = {}) {
    return Teacher.getSubjects().then(response => {
      context.commit('SET_SUBJECT_LISTS', response)
    })
  }
}
